import { Injectable, Inject, PLATFORM_ID, Optional, Injector } from '@angular/core';
import {CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import { AngularFireAuth } from '@angular/fire/compat/auth';
import { map, take, Observable, of, switchMap, from } from 'rxjs';
import { filter, timeout, catchError } from 'rxjs/operators';
import { isPlatformBrowser } from '@angular/common';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { AuthService } from 'src/app/features/services/auth/auth.service';




@Injectable()
export class UserRoleAuthGuard implements CanActivate {

  private auth: AngularFireAuth | null = null;

  constructor(
    private router: Router, 
    public snackBar: MatSnackBar,
    @Inject(PLATFORM_ID) private platformId: Object,
    private injector: Injector,
     private afs: AngularFirestore,
     private authService: AuthService,
  ) {
    // Only try to inject AngularFireAuth if we're in browser environment
    if (isPlatformBrowser(this.platformId)) {
      try {
        this.auth = this.injector.get(AngularFireAuth, null);
      } catch (error) {
        this.auth = null;
      }
    }
  }

/* canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    return this.auth.getUser()?.pipe(
      map(user => !!user),
      tap(authenticated => {
        authenticated || this.router.parseUrl('auth/login')
      })
    )
    }*/
    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
      if (!isPlatformBrowser(this.platformId) || !this.auth) {
        return of(false);
      }
      if (this.authService.isSessionExpired()) {
        void this.authService.forceSessionExpiryLogout();
        return of(false);
      }
      const afAuth = this.auth;
        const allowedRoles: string[] | undefined = route.data['roles'];
      // currentUser waits for Firebase Auth to restore; authState.take(1) can
      // be null on a hard redirect and wrongly send SuperAdmin to /auth/login.
      return from(afAuth.currentUser).pipe(
      switchMap(user => {
        if (user) {
          return of(user);
        }
        return afAuth.authState.pipe(
          filter((u) => !!u),
          take(1),
          timeout(4000),
          catchError(() => of(null)),
        );
      }),
      switchMap(user => {

        if (!user) {
          this.router.navigate(['/auth/login']);
          return of(false);
        }
        if (this.authService.sessionNeedsReauth(true)) {
          void this.authService.forceSessionExpiryLogout();
          return of(false);
        }

        return this.afs.doc(`users/${user.uid}`).valueChanges().pipe(
          take(1),
          switchMap((userData: any) => {
            if ((userData?.status || '').toLowerCase() === 'blocked') {
              void this.authService.doSignout();
              this.router.navigate(['/auth/login']);
              return of(false);
            }
            if (!allowedRoles || allowedRoles.length === 0) {
              return of(true);
            }
            const role = userData?.role;
            if (allowedRoles.includes(role)) {
              return of(true);
            }
            // Real “Connect to” only: Firebase adminLogin claim (not stale localStorage adminID).
            const allowConnectAs = !!route.data['allowConnectAs'];
            if (!allowConnectAs) {
              this.router.navigate(['/home']);
              return of(false);
            }
            return from(user.getIdTokenResult(false)).pipe(
              map((idTokenResult) => {
                const v = idTokenResult?.claims?.['adminLogin'];
                const isAdminAsUser = v === true || v === 'true';
                if (isAdminAsUser) {
                  return true;
                }
                this.router.navigate(['/home']);
                return false;
              }),
            );
          })
      );
    })
  );
    }
}
